import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/chris-hobbs",
    component: _cffe3db6,
    name: "chris-hobbs"
  }, {
    path: "/christene-dino-hobbs-ricp",
    component: _cffe3db6,
    name: "christene-dino-hobbs-ricp"
  }, {
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/heather-b-bates-mba",
    component: _cffe3db6,
    name: "heather-b-bates-mba"
  }, {
    path: "/jessi-munns",
    component: _cffe3db6,
    name: "jessi-munns"
  }, {
    path: "/lindsay-coxe",
    component: _cffe3db6,
    name: "lindsay-coxe"
  }, {
    path: "/about-us/meet-our-team",
    component: _cffe3db6,
    name: "meet-our-team"
  }, {
    path: "/about-us/working-together",
    component: _cffe3db6,
    name: "working-together"
  }, {
    path: "/expertise/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/expertise/personal-solutions",
    component: _cffe3db6,
    name: "personal-solutions"
  }, {
    path: "/expertise/why-our-clients-choose-us",
    component: _cffe3db6,
    name: "why-our-clients-choose-us"
  }, {
    path: "/resources/articles",
    component: _cffe3db6,
    name: "articles"
  }, {
    path: "/resources/life-stages",
    component: _cffe3db6,
    name: "life-stages"
  }, {
    path: "/resources/videos",
    component: _cffe3db6,
    name: "videos"
  }, {
    path: "/resources/articles/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/resources/articles/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "untitled"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
